"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var uiTest = function uiTest(classFragment) {
  if (!classFragment || process.env.NODE_ENV !== 'development') {
    return '';
  }

  return "test-".concat(classFragment);
};

var _default = uiTest;
exports.default = _default;